import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/sino-cmsContentad/cmsContentad/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/sino-cmsContentad/cmsContentad/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/sino-cmsContentad/cmsContentad/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/sino-cmsContentad/cmsContentad/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/sino-cmsContentad/cmsContentad/submit',
    method: 'post',
    data: row
  })
}

export const cmsListByType = (params) => {
  return request({
    url: '/api/sino-cmsContentad/cmsContentad/cmsListByType',
    method: 'get',
    params: {
      ...params,
    }
  })
}

